module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00293.16de48cc.jpg";